<button 
  mat-icon-button 
  [matMenuTriggerFor]="notificationMenu"
  [matTooltip]="getTooltipText(summary$ | async)"
  class="notification-bell-button"
  [class.has-urgent]="hasUrgentNotifications(urgentNotifications$ | async)"
  #menuTrigger="matMenuTrigger">
  
  <mat-icon 
    matBadge="{{ getBadgeContent(summary$ | async) }}"
    [matBadgeHidden]="(summary$ | async)?.unreadCount === 0"
    matBadgeColor="warn"
    matBadgeSize="small"
    matBadgePosition="above after">
    notifications
  </mat-icon>
</button>

<mat-menu 
  #notificationMenu="matMenu" 
  class="notification-dropdown-menu"
  xPosition="before"
  yPosition="below">
  
  <!-- Notification list in dropdown -->
  <div class="notification-menu-content" (click)="$event.stopPropagation()" (keydown.enter)="$any($event).stopPropagation()" tabindex="0">
    
    <!-- Header -->
    <div class="notification-menu-header">
      <span class="menu-title">{{ 'shared.notifications.title' | translate }}</span>
      <button 
        mat-button 
        class="view-all-button"
        (click)="viewAllNotifications(); menuTrigger.closeMenu()" (keydown.enter)="viewAllNotifications(); menuTrigger.closeMenu()">
        {{ 'shared.notificationBell.viewAll' | translate }}
      </button>
    </div>
    
    <!-- Contextual opt-in (#285). Self-hiding: nothing renders once the browser
         has an answer, or once the user has said "later" on this machine. -->
    <app-push-opt-in-banner></app-push-opt-in-banner>

    <!-- Notification list (compact mode) -->
    <div class="notification-menu-list">
      <app-notification-list
        [maxItems]="5"
        [showGrouping]="false"
        [showActions]="false"
        [compact]="true"
        (notificationClicked)="onNotificationClick($event); menuTrigger.closeMenu()">
      </app-notification-list>
    </div>
    
    <!-- Footer -->
    <div class="notification-menu-footer">
      <mat-divider></mat-divider>
      <button 
        mat-button 
        color="primary"
        class="view-all-footer-button"
        (click)="viewAllNotifications(); menuTrigger.closeMenu()" (keydown.enter)="viewAllNotifications(); menuTrigger.closeMenu()">
        <mat-icon>open_in_new</mat-icon>
        {{ 'shared.notificationBell.viewAllNotifications' | translate }}
      </button>
    </div>
    
  </div>
</mat-menu> 